import { useState, useEffect } from 'react'
import { Wrapper, Status } from '@googlemaps/react-wrapper'
import { Marker } from '../components'
import { MapBase } from './MapBase'
import { DEFAULT_RIC_LOCATION, GOOGLE_MAPS_API_KEY } from '../common/constants'
import { useAccountContext } from '../contexts'
import { DeviceInfo } from '../common/enums'
import { SubLayout } from '../layouts/SubLayout'

// https://developers.google.com/maps/documentation/javascript/react-map

const INITIAL_ZOOM = 14

interface Props {
  focus: any
  selectDevice: (sigfoxId: string) => void
}

export function Map({ focus, selectDevice }: Props) {
  const { selectedDevice, devices } = useAccountContext()

  const [map, setMap] = useState<google.maps.Map>() // initial zoom
  const [zoom, setZoom] = useState(INITIAL_ZOOM) // initial zoom
  const [center, setCenter] = useState<google.maps.LatLngLiteral>({
    lat: focus.lat,
    lng: focus.lng,
  })

  useEffect(() => {
    if (map) {
      map.panTo(focus)
    }
  }, [map, focus])

  function getPosition(device: DeviceInfo): google.maps.LatLngLiteral {
    const lat = device.coordinateNSValue || DEFAULT_RIC_LOCATION.lat
    const lng = device.coordinateEWValue || DEFAULT_RIC_LOCATION.lng
    return { lat, lng }
  }

  function onClick(e: google.maps.MapMouseEvent, map: google.maps.Map) {
    // avoid directly mutating state
    // setMarkers([...markers, e.latLng!])
    // map.panTo(e.latLng!)
  }

  function onIdle(m: google.maps.Map) {
    setMap(m)
    setZoom(m.getZoom()!)
    setCenter(m.getCenter()!.toJSON())
  }

  function render(status: Status) {
    return <h1>{status}</h1>
  }

  return (
    <SubLayout>
      <Wrapper apiKey={GOOGLE_MAPS_API_KEY} render={render}>
        <MapBase
          center={center}
          onClick={onClick}
          onIdle={onIdle}
          zoom={zoom}
          fullscreenControl={false}
          streetViewControl={false}
          mapTypeControlOptions={{
            // style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: ['roadmap', 'satellite', 'hybrid'],
          }}
          style={{ flexGrow: '1', height: '100%' }}
        >
          {Object.values(devices)
            // .filter((d) => Object.keys(d.readings).length > 0)
            // .filter(onlyUnique)
            .map((device: DeviceInfo, index: number) => {
              return (
                <Marker
                  key={index}
                  sigfoxId={device.sigfoxId}
                  position={getPosition(device)}
                  index={index}
                  selectDevice={selectDevice}
                  selected={device.sigfoxId === selectedDevice}
                />
              )
            })}
        </MapBase>
      </Wrapper>
    </SubLayout>
  )
}
